



























import Vue from 'vue';
import { mapActions, mapGetters } from 'vuex';

import { ModalSize } from '@/components/zen_modal/types';
import GenericCard from '@/components/cards/GenericCard.vue';

export default Vue.extend({
  name: 'ControlReviewCard',
  components: {
    GenericCard,
  },
  props: {
    program: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapGetters(['routes']),
    redirectUrl() {
      return (
        this.routes.sorInfo
          .replace('__OBJECT_TYPE__', this.program.__typename)
          .replace('__OBJECT_ID__', this.program.dbId)
          .replace('__TAB__', 'mapped') + '/Controls'
      );
    },
  },
  created() {
    this.changeModalSize(ModalSize.Small);
  },
  methods: {
    ...mapActions({
      changeModalSize: 'modals/changeSize',
      cancelModal: 'modals/cancel',
    }),
    redirectToProgram() {
      document.location.href = this.redirectUrl;
    },
  },
});
